import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PatientHistory } from "@/components/history/PatientHistory";
import { UserSessionLogs } from "@/components/history/UserSessionLogs";
import FollowUps from "@/pages/FollowUps";
import { MainLayout } from "@/components/layout/MainLayout";
import { useAuthStore } from "@/lib/auth";

export default function History() {
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'admin';

  // No automatic view logging to reduce noise

  return (
    <MainLayout>
      <div className="container mx-auto py-6 space-y-6">
        <Tabs defaultValue="patients" className="space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <h1 className="text-2xl font-bold">History</h1>
            <TabsList className="w-full sm:w-auto">
              <TabsTrigger
                value="patients"
                className="text-xs sm:text-sm transition-all duration-300 data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-blue-700 data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:font-semibold data-[state=active]:scale-105 data-[state=active]:ring-2 data-[state=active]:ring-blue-400/50 data-[state=inactive]:hover:bg-gray-200/50"
              >
                <span className="hidden sm:inline">Patient History</span>
                <span className="sm:hidden">Patients</span>
              </TabsTrigger>
              {isAdmin && (
                <>
                  <TabsTrigger
                    value="followups"
                    className="text-xs sm:text-sm transition-all duration-300 data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-blue-700 data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:font-semibold data-[state=active]:scale-105 data-[state=active]:ring-2 data-[state=active]:ring-blue-400/50 data-[state=inactive]:hover:bg-gray-200/50"
                  >
                    <span className="hidden sm:inline">Follow-ups</span>
                    <span className="sm:hidden">Follow-ups</span>
                  </TabsTrigger>
                  <TabsTrigger
                    value="sessions"
                    className="text-xs sm:text-sm transition-all duration-300 data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-blue-700 data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:font-semibold data-[state=active]:scale-105 data-[state=active]:ring-2 data-[state=active]:ring-blue-400/50 data-[state=inactive]:hover:bg-gray-200/50"
                  >
                    <span className="hidden sm:inline">User Sessions</span>
                    <span className="sm:hidden">Sessions</span>
                  </TabsTrigger>
                </>
              )}
            </TabsList>
          </div>

          <TabsContent value="patients">
            <PatientHistory />
          </TabsContent>

          {isAdmin && (
            <>
              <TabsContent value="followups">
                <FollowUps />
              </TabsContent>
              <TabsContent value="sessions">
                <UserSessionLogs />
              </TabsContent>
            </>
          )}
        </Tabs>
      </div>
    </MainLayout>
  );
}
